module.exports = __webpack_public_path__ + "static/img/a020.992cf86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a020.jpg
// module id = WnIM
// module chunks = 0